import { ftlEquipmentTypes } from 'legacy/components/EquipmentTypeSelect/equipmentTypes'

const VALID_TYPES = ftlEquipmentTypes.map(someEquipType => someEquipType.value)
const DEFAULT_VALUE = VALID_TYPES.join(',')

function sanitizeEquipmentQueryString(currentValue) {
  const activeTypes = (currentValue || '').split(',') || []
  const validActiveTypes = activeTypes.filter(someType => VALID_TYPES.includes(someType))

  if (validActiveTypes.length <= 0) {
    return DEFAULT_VALUE
  }

  return currentValue
}

export { sanitizeEquipmentQueryString }
